import { observable, action } from 'mobx'
import { Request2 } from 'src/common/Request2'
import api from 'src/common/api'

export interface WebhookConfigData {
   id?: number
   accountId?: number
   url?: string
   secret?: string | null
   isActive?: boolean
   autoPayment?: boolean
}

export class WebhookConfigStore {
   @observable webhookConfig: WebhookConfigData | null = null

   // Build URL tuyệt đối tới route v2 (baseURL mặc định của Request2 là /v1).
   private buildUrl(path: string) {
      return `${api.URI_ENDPOINT_V2}${path}`
   }

   @action
   async getConfig() {
      const result = await Request2.getWithTokenNoMessage(this.buildUrl(api.webhookConfig.get))
      // Khi chưa cấu hình, backend trả data = null -> Request2 trả về true.
      if (result && typeof result === 'object') {
         this.webhookConfig = result
      } else {
         this.webhookConfig = null
      }
      return this.webhookConfig
   }

   @action
   async upsertConfig(data: {
      url?: string
      secret?: string | null
      isActive?: boolean
      autoPayment?: boolean
   }) {
      const result = await Request2.putWithToken(data, this.buildUrl(api.webhookConfig.upsert))
      if (result?.data && typeof result.data === 'object') {
         this.webhookConfig = result.data
      }
      return result
   }

   @action
   async deleteConfig() {
      const result = await Request2.deleteWithToken({}, this.buildUrl(api.webhookConfig.delete))
      if (result) {
         this.webhookConfig = null
      }
      return result
   }

   @action
   async testConfig() {
      const result = await Request2.postWithToken({}, this.buildUrl(api.webhookConfig.test))
      return result
   }
}
